import React from 'react'
import { Box, Button, Container, Grid, TextField, Typography, } from '@mui/material';
import { Link } from "react-router-dom";
import Divider from '@mui/material/Divider';
import LikeButton from "../../../Views/Like/likebutton";
import { ABI, API_URL, APP_URL, bsccontractaddress, maticcontractaddress } from '../../../Config';
import { useState } from 'react';
import { useWeb3React } from '@web3-react/core';
import swal from "sweetalert";
import Loading from "../../../Components/loader/loader";
import axios from 'axios';
import notrevealed from '../../../images/notrevealed.jpg';

/* global BigInt */

const Ownednft = (props) => {
    const { library, account } = useWeb3React();
    const [isloading,setisloading]=useState(false);
    const update=async(tokenId ,resellprice)=>{

        var data =new FormData();
        data.append("NFT_id",tokenId);
        data.append("NFTprice",resellprice);

        return await axios.post(`${API_URL}/Resell.php`, data, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
    }
    return (
        <div>
            <Box className="Profile_">
                <Container maxWidth='xl'>
                    <Grid container spacing={1}>
                        {props.Ownedprop.length > 0 && props.Ownedprop.map((data, index) => (
                            <Grid key={index} item lg={3} sm={6} md={6} xs={12} marginBottom='30px'>
                                <Box className='Profile_inner'>
                                    <Box>
                                    <Link to={`./Buydetails/${data.NFT_id}`} > 
                                    {data.NFT_image.split('.').pop()== "png" ||data.NFT_image.split('.').pop()=='jpg'||data.NFT_image.split('.').pop()=='jpeg'?
                                    <img src={data.Private==0?APP_URL+'/'+data.NFT_image:notrevealed} width='100%' className='base_pht' style={{ borderRadius: '5px' }} /> 
                                    :data.NFT_image.split('.').pop()== "mp4" ?
                                    <video width="750" height="500" controls >
                                        <source src={data.Private==0?APP_URL+'/'+data.NFT_image:notrevealed} type="video/mp4"/>
                                    </video>
                                    :data.NFT_image.split('.').pop()== "mp3" ||data.NFT_image.split('.').pop()=='aac'?
                                    <audio controls>
                                    <source src={data.Private==0?APP_URL+'/'+data.NFT_image:notrevealed} type="audio/mpeg"/>
                                    Your browser does not support the audio tag.
                                    </audio> 
                                    :<img src={data.Private==0?APP_URL+'/'+data.NFT_image:notrevealed} width='100%' style={{ borderRadius: '5px' }} />
                                    } 
                                    </Link>
                                    </Box>
                                    <Box display='flex' justifyContent='space-between' paddingY='10px'>
                                        <Box>
                                            <Typography fontWeight='600' fontSize='22' variant='h6' color='#000'>
                                                <Link to={`./Buydetails/${data.NFT_id}`}>{data.Private==0?data.NFT_name:"SECRET NFT"}</Link>
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <LikeButton nft={data}/>
                                        </Box>
                                    </Box>
                                    <Divider />
                                    <Box paddingBottom='10px'>
                                        <Box justifyContent='space-between' position='relative'>
                                            <Typography variant='h5' color='#000' fontWeight='600' fontSize='16px'>
                                                Reserved price
                                            </Typography>
                                            <Typography fontWeight='500' variant='h6' fontSize='15px' color='#000'>
                                                {data.NFT_price} {data.NFT_payment}
                                            </Typography>
                                            {data.NFT_resell === "off" && (
                                            <Link to={`./Resell/${data.NFT_id}`}>
                                                <Button variant='contained' className='resell_nft' fullWidth >Resell</Button>
                                            </Link> )}
                                        </Box>
                                     
                                             

                                    </Box>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>
            {isloading && <Loading props={'Transaction in process, Please wait do not refresh the page...'}/>}
        </div>
    )
}

export default Ownednft;  